import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import ConsultantLayout from "../commonlayouts/consultantlayout"; 
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link, useNavigate } from 'react-router-dom';
import SampleTemplate from "../assets/documents/sampleleads.xlsx";
import Swal from "sweetalert2";
import { AddLeads_BulkImport } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";



const Addbulkleads = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userGuid, setUserGuid] = useState("");
   const navigate= useNavigate();
   let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const token = localStorage.getItem("jwtToken");
  const roleID = localStorage.getItem("roleID")
      const {selectedCountry}=useCountry();
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }

    useEffect(() => {
     const storedUserGuid = localStorage.getItem("guid");
      if (storedUserGuid) {
        setUserGuid(storedUserGuid);
      }
    }, []);
  
    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };
  

    const email = localStorage.getItem("email")
   const handleImport = async () => {
      if (!file) {
        setError("Please select a file.");
        return;
      }
  
      setLoading(true);
      setError(null);
  
      try {
        // Read the Excel file
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        
        function excelDateToJSDate(excelDate) {
          if (!excelDate || excelDate === "" || excelDate < 1) {
              return "";
          }
      
          // Convert Excel date serial number to JavaScript Date object
          const date = new Date((excelDate - (25567 + 2)) * 86400 * 1000);
      
          // Check if the date is the default "1899-12-30" and return an empty string if true
          if (date.getTime() === new Date("1899-12-30").getTime()) {
              return "";
          }
      
          // Format the date as YYYY-MM-DD
          const day = ("0" + date.getDate()).slice(-2);
          const month = ("0" + (date.getMonth() + 1)).slice(-2);
          const year = date.getFullYear();
          return `${year}-${month}-${day}`;
      }


      const validateData = (data) => {
        for (let item of data) {
          if (!item.fullName && !item.phoneNumber) {
            Swal.fire({
              icon: 'error',
              title: 'Missing Required Fields',
              text: 'Name and Phone Number are required!',
            });
            setLoading (false);
            return false;
           
          }else
          if (!item.phoneNumber) {
            Swal.fire({
              icon: 'error',
              title: 'Missing Required Fields',
              text: 'Phone Number is required!',
            });
            setLoading (false);
            return false;
          }
          else
          if (!item.fullName) {
            Swal.fire({
              icon: 'error',
              title: 'Missing Required Fields',
              text: 'name is required!',
            });
            setLoading (false);
            return false;
          }
        }
        return true;
      };
        // Format the JSON data
        if (validateData(jsonData)) {
       const formattedData = jsonData.map((item) => ({
        fullName: item.fullName,
        email: item.email?item.email:"",
        phoneNumber: item.phoneNumber.toString(),
        dateOfBirth:  excelDateToJSDate(item?.dateOfBirth?item.dateOfBirth:""),
        linkdinUrl: item.linkedInUrl?item.linkedInUrl:"",
        websiteURL: item.websiteURL?item.websiteURL:"",
        companyName: item.companyName?item.companyName:"",
        domain: item.domain?item.domain:"",
        createdBy: email,
        userGuid: Guid,
        countryID:selectedCountry
    }));
  
        const response = await axios.post(
         AddLeads_BulkImport.APIURL,
          formattedData,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          }
        );
        if (response.data.message === 'Record created successfully') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Added Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          navigate("/Employer/ListOfLeads")

          // toast.success('Data Saving', {autoClose:5000})

        }
        else {
          // toast.error('Issue with data format', {autoClose:5000})
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Add correct File',
            showConfirmButton: false,
            timer: 5000
          })
        }
  
        setLoading(false);
      } }catch (error) {
        console.error("Import error:", error);
        setError("Error occurred during import. Please try again.");
        setLoading(false);
      }
    };
  
    return (
      <ConsultantLayout>
        <section>
          <div className="container-fluid mt-4 pb-5">
            <div className="row">
              <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListOfLeads">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Import Leads</h2>
</div>
              </div>
              <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3'>
            <div style={{ float: "right" }}>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Sample Excel</Tooltip>)}>

              <a href={SampleTemplate} download="SampleLeadsFile.xlsx">  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-download"></i></button> </a>
                 </OverlayTrigger>
             
            </div>
          </div>
            </div>
            <hr />
            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
              <div className="">
                <div className="" style={{ background: "#f8f8f8"}}>
                  <div className="d-flex">
                      <div >
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Excel File</Tooltip>)}>

                    <input type="file"  className=" form-control"onChange={handleFileChange} />
                   </OverlayTrigger> </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                   
                    <button style={{marginLeft:15 }} onClick={handleImport}  className="btn btn-primary ">
                    {loading ? "Importing..." : "Import"}
                        </button>
                    
                  </div>
                 
  </div>
                </div>
  
              </div>
            </div>
          </div>
        </section>
      </ConsultantLayout>
    );
  };
  
  export default Addbulkleads;